import { Box, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface LayoutWithIconsProps {
  children: React.ReactNode;
  onNavigate: (direction: "previous" | "next") => void;
}

const LayoutWithIcons: React.FC<LayoutWithIconsProps> = ({
  children,
  onNavigate,
}) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      justifyContent="center"
    >
      <IconButton
        sx={{
          borderRadius: "50%",
          marginBottom: "1vh",
          marginTop: "1vh",
          "&.MuiIconButton-root": {
            backgroundColor: "primary.main",
            color: "white !important",
          },
        }}
        onClick={() => onNavigate("previous")}
        size="small"
      >
        <ChevronLeftIcon />
      </IconButton>
      <Box sx={{ margin: "1vh" }}>{children}</Box>
      <IconButton
        sx={{
          borderRadius: "50%",
          marginBottom: "1vh",
          marginTop: "1vh",
          "&.MuiIconButton-root": {
            backgroundColor: "primary.main",
            color: "white !important",
          },
        }}
        onClick={() => onNavigate("next")}
        size="small"
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
};

export default LayoutWithIcons;
